import { Component, Input } from '@angular/core'

@Component({
  selector: 'ddc-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.scss'],
})
export class DdcDividerComponent {
  @Input() text: string = ''
}
